import { Layout, LayoutProps } from 'react-admin';
import Menu from './Menu';
import AppBar from './AppBar';

const Layouts = (props: LayoutProps) => {
    return <Layout {...props} menu={Menu} appBar={AppBar} />;
};

export default Layouts;
